
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.708 9.29196C11.8011 9.38485 11.875 9.4952 11.9254 9.61669C11.9759 9.73818 12.0018 9.86842 12.0018 9.99996C12.0018 10.1315 11.9759 10.2617 11.9254 10.3832C11.875 10.5047 11.8011 10.6151 11.708 10.708L6.41402 16L11.708 21.292C11.801 21.3849 11.8747 21.4953 11.9251 21.6168C11.9754 21.7383 12.0013 21.8685 12.0013 22C12.0013 22.1314 11.9754 22.2616 11.9251 22.3831C11.8747 22.5046 11.801 22.615 11.708 22.708C11.615 22.8009 11.5047 22.8747 11.3832 22.925C11.2617 22.9753 11.1315 23.0012 11 23.0012C10.8685 23.0012 10.7383 22.9753 10.6169 22.925C10.4954 22.8747 10.385 22.8009 10.292 22.708L4.29202 16.708C4.19889 16.6151 4.12501 16.5047 4.07459 16.3832C4.02418 16.2617 3.99823 16.1315 3.99823 16C3.99823 15.8684 4.02418 15.7382 4.07459 15.6167C4.12501 15.4952 4.19889 15.3848 4.29202 15.292L10.292 9.29196C10.3849 9.19883 10.4953 9.12494 10.6168 9.07453C10.7382 9.02412 10.8685 8.99817 11 8.99817C11.1316 8.99817 11.2618 9.02412 11.3833 9.07453C11.5048 9.12494 11.6151 9.19883 11.708 9.29196Z","fill":"#fd5105"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 16C5 15.7348 5.10536 15.4804 5.29289 15.2929C5.48043 15.1054 5.73478 15 6 15H27C27.2652 15 27.5196 15.1054 27.7071 15.2929C27.8946 15.4804 28 15.7348 28 16C28 16.2652 27.8946 16.5196 27.7071 16.7071C27.5196 16.8946 27.2652 17 27 17H6C5.73478 17 5.48043 16.8946 5.29289 16.7071C5.10536 16.5196 5 16.2652 5 16Z","fill":"#fd5105"}})])
          )
        }
      }
    